import React, { FC } from 'react';
import { StyledLink } from '@/ui/globalStyles';
import { AppPaths } from '@/routes';
import { OtherInspection } from '@/types';
import { currencyFormatted, localDateFormatted } from '@/utils/helpers';

interface OtherInspectionsTableProps {
  data: OtherInspection[];
}
export const OtherInspectionsTable: FC<OtherInspectionsTableProps> = ({
  data,
}) => {
  return data.length ? (
    <div style={{ maxHeight: 200, overflowY: 'auto' }}>
      <table className="w-100">
        <thead>
          <tr>
            <th className="fw-semibold" style={{ width: 80 }}>
              ID
            </th>
            <th className="fw-semibold">Site</th>
            <th className="fw-semibold">Date</th>
            <th className="fw-semibold">Status</th>
            <th className="fw-semibold">Authorised cost</th>
          </tr>
        </thead>
        <tbody>
          {data.map((inspection) => (
            <tr key={inspection.id}>
              <td>
                <StyledLink
                  onClick={() =>
                    window.open(
                      `/${AppPaths.inspection}/${inspection.id}`,
                      '_blank',
                    )
                  }
                >
                  {inspection.id}
                </StyledLink>
              </td>
              <td className="text-muted">{inspection.inspectionLocation}</td>
              <td className="text-muted">
                {localDateFormatted(inspection.inspectionDateTime)}
              </td>
              <td className="text-muted">{inspection.inspectionStatusName}</td>
              <td className="text-muted">
                {currencyFormatted(inspection.authorisedApprovalCost)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : null;
};
